import React from "react";
import ProductCard from "web/react/components/product-card/react/product-card";
import { HStack } from "web/react/emo/h-stack";
import {
    ProductCardDetails,
    ProductCardPrice,
    ProductCardWishlist,
    ProductImage,
} from "web/react/emo/product-card";
import { VStack } from "web/react/emo/v-stack";
import { ProductCardSerializer } from "web/types/serializers";

interface CollectionProductCardProps {
    product: ProductCardSerializer;
    sponsored: boolean;
    sendClickEvent: (area: string) => void;
}

export function CollectionProductCard({
    product,
    sponsored,
    sendClickEvent,
}: CollectionProductCardProps): React.ReactElement {
    return (
        <div data-testid="collection-product-card">
            <ProductCard product={product}>
                <VStack spacing="sm">
                    <div
                        data-testid="collection-product-image"
                        onClick={() => sendClickEvent("image")}
                    >
                        <ProductImage shouldRenderLeadLinkInImage={sponsored} />
                    </div>
                    <VStack spacing="xxs">
                        <HStack justify="space-between">
                            <ProductCardPrice size={"lg"} style={"secondary"} />
                            <ProductCardWishlist
                                beforeOnClick={() => sendClickEvent("link")}
                                isSavedForLater={product.is_saved_for_later}
                            />
                        </HStack>
                        <ProductCardDetails
                            beforeOnClick={() => sendClickEvent("link")}
                            shouldRenderLeadLink={sponsored}
                        />
                    </VStack>
                </VStack>
            </ProductCard>
        </div>
    );
}
